const style = {
  menu: {
    position: 'fixed',
    width: '330px',
    top: '50px',
    right: '-330px',
    transition: 'all 0.25s ease-in-out',
    height: 'calc(100vh - 50px)',
    maxHeight: 'calc(100vh - 50px)',
    backgroundColor: 'white',
    color: 'initial',
    zIndex: '1052',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)',
    overflowY: 'auto',
    padding: '10px',
  },
  background: {
    position: 'absolute',
    top: '50px',
    left: '0',
    width: '100%',
    height: 'calc(100vh - 50px)',
    transition: 'opacity 0.5s ease-in-out',
    opacity: '0',
    zIndex: '-1',
    backgroundColor: 'rgba(90, 90, 90, 0.4)',
  },
  quesito: {
    marginBottom: '5px',
    borderBottom: '1px solid #ccc',
    cursor: 'pointer',
    padding: '5px',
  },
  subHeader: {
    fontSize: '12px',
  },
  data: {
    fontSize: '12px',
  },
  header: {
    marginBottom: '5px',
  },
  tag: {
    backgroundColor: '#e6e6e6',
    padding: '3px 5px 3px 12px',
    borderRadius: '16px',
    marginRight: '5px',
    display: 'inline-block',
    marginBottom: '5px',
    fontSize: '12px',
    height: '20px',
    lineHeight: '14px',
    cursor: 'pointer',
    fontWeight: '700',
  },
  stileQuesito: {
    backgroundColor: '#d4ebfd',
    margin: '20px 20px 20px 60px',
    borderRight: '7px solid #2a9cf4',
    textAlign: 'right',
    listStyleType: 'none',
  },
  badgeTitoli: {
    position: 'relative',
    top: '-2px',
    left: '10px',
  },
  vaiAdAreaPersonale: {
    float: 'right',
    lineHeight: '31px',
    color: '#428bca',
  },
  dividerTitolo: {
    margin: '0',
    display: 'block',
    height: '1px',
    border: '0',
    borderTop: '1px solid #ccc',
    padding: '0',
  },
  anteprima__loading: {
    marginTop: '50%',
  },
  container: {
    position: 'relative',
    display: 'block',
    float: 'right',
  },
  containerOpen: {},
};

style.menuOpen = { ...style.menu, right: '0px', padding: '10px' };

style.previewOpen = { ...style.menu, right: '0px', width: '660px' };

style.backgroundOpen = { ...style.background, opacity: '1', zIndex: '1000' };

style.quesitoHover = { ...style.quesito, backgroundColor: '#ebebeb' };

style.stileQuesitoOperatore = {
  ...style.stileQuesito,
  backgroundColor: '#ebebeb',
  margin: '20px 60px 20px 20px',
  borderLeft: '7px solid #a09c9c',
  borderRight: 'none',
};

style.stileQuesitoSistema = {
  ...style.stileQuesito,
  backgroundColor: 'transparent',
  margin: '10px 20px',
  padding: '0',
  border: 'none',
  textAlign: 'center',
  fontSize: '12px',
  lineHeight: '14px',
};

export default style;
